var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer 51",
    d: "M11.5714 5.57121H1.45955L6.30327 0.734351C6.34324 0.694406 6.37494 0.646984 6.39657 0.594793C6.4182 0.542602 6.42933 0.486664 6.42933 0.430173C6.42933 0.373682 6.4182 0.317744 6.39657 0.265553C6.37494 0.213362 6.34324 0.16594 6.30327 0.125995C6.2633 0.0860495 6.21586 0.0543632 6.16364 0.0327449C6.11142 0.0111267 6.05545 0 5.99893 0C5.88478 0 5.77531 0.0453217 5.69459 0.125995L0.12217 5.69546C0.0831461 5.7362 0.0525556 5.78425 0.0321544 5.83683C-0.0107181 5.94114 -0.0107181 6.05813 0.0321544 6.16243C0.0525556 6.21502 0.0831461 6.26307 0.12217 6.30381L5.69459 11.8733C5.73444 11.9134 5.78185 11.9453 5.83408 11.9671C5.88632 11.9888 5.94234 12 5.99893 12C6.05552 12 6.11154 11.9888 6.16378 11.9671C6.21601 11.9453 6.26342 11.9134 6.30327 11.8733C6.34345 11.8334 6.37534 11.7861 6.3971 11.7339C6.41886 11.6816 6.43006 11.6257 6.43006 11.5691C6.43006 11.5125 6.41886 11.4565 6.3971 11.4043C6.37534 11.3521 6.34345 11.3047 6.30327 11.2649L1.45955 6.42805H11.5714C11.685 6.42805 11.7941 6.38292 11.8745 6.30257C11.9548 6.22223 12 6.11326 12 5.99963C12 5.88601 11.9548 5.77704 11.8745 5.6967C11.7941 5.61635 11.685 5.57121 11.5714 5.57121Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer51);
export default __webpack_public_path__ + "static/media/Layer 51.a3e487398706f4c9c74a7fd04364ad27.svg";
export { ForwardRef as ReactComponent };